/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyPasscodeAndExpiration} from '../api'

export const useMutationVerifyPasscodeAndExpiration = createReactQueryMutationHook('verifyPasscodeAndExpiration', verifyPasscodeAndExpiration)
